﻿/**
 * portal-group-list.controller
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.portal').controller('portal-group-list.controller', portalGroupListController);

	/** setup injection */
	portalGroupListController.$inject = ['$timeout', 'portal-link-group.repository', 'portal-link.repository'];

	/** implementation */
	function portalGroupListController($timeout, portalLinkGroupRepository, portalLinkRepository) {
		/** pubic properties */
		var vm = this;
		vm.loading = false;
		vm.portalGroups = [];
		vm.searching = false;
		vm.searchString = '';
		vm.searchResults = [];

		/** public methods */
		vm.searchLinks = searchLinks;
		vm.closeSearch = closeSearch;

		/** run init */
		init();

		/** public method implementations */

		/** search for links */
		function searchLinks() {
			/** reset matches */
			vm.searchResults = [];

			/** check the length */
			if (vm.searchString.length < 2) return;

			/** place search in timeout so that old results don't still display */
			$timeout(function() {
				/** flip searching flag */
				vm.searching = true;

				/** load portal links */
				portalLinkRepository.search(vm.searchString).then(function(matches) {
					/** set search results */
					vm.searchResults = matches;

					/** flip searching flag */
					vm.searching = false;
				});
			}, 100);
		}

		/** close the search results */
		function closeSearch() {
			/** reset values */
			vm.searchString = '';
			vm.searchResults = [];
		}

		/** private methods */
		
		/** initialize */
		function init() {
			/** flip loading flag */
			vm.loading = true;

			/** load portal links */
			portalLinkGroupRepository.getForUser().then(function(portalGroups) {
				/** set portal groups */
				vm.portalGroups = portalGroups.filter(function(g){ return g.linkCount > 0; });

				/** flip loading flag */
				vm.loading = false;
			});
		}
	}
})();